module.exports = __webpack_public_path__ + "img/works_xikemu_dx_5.fa475065.jpg";